import { useFormApi } from '@data-driven-forms/react-form-renderer';

type FormProps = {
  fields?: React.ReactNode[] | any[];
};

export default function Form({ fields = [] }: Readonly<FormProps>) {
  const { renderForm } = useFormApi();

  return <>{!!fields?.length && fields.map((field) => renderForm([field]))}</>;
}
